module.exports = __webpack_public_path__ + "img/personal.8c0da797.svg";